<template>
  <q-page padding class=" column ">
    <div class="col-1">
      <h4 class="q-ma-xs">Проекты</h4>
    </div>
    <div class="col-11 row">
      <div class="col-12 col-sm-3 q-pa-sm">
        <q-list dense padding class="rounded-borders">
          <q-item-label header>Категории</q-item-label>
          <q-item-section>
            <ProjectTypeItem
                v-for="projectType in projectTypes"
                :key="projectType.id"
                :item="projectType"
                :level="0.5"
                :selected-id="selectedProjectType?.id"
                :is-admin="user.admin || user.anyAdmin"
                :is-any-admin="user.anyAdmin"
                @delete="(item) => deleteProjectType(item)"
                @select="(item) =>  select(item)"
                @add="(item) =>  addProjectType(item)"
                @edit="(item) => editProjectType(item)"
                @transfer="(item) => transferProjectType(item)"
            />
          </q-item-section>

          <q-item clickable v-ripple @click="addProjectType()">
            <q-item-section avatar>
              <q-icon name="add"/>
            </q-item-section>
            <q-item-section>Новая категория</q-item-section>
          </q-item>
        </q-list>
      </div>
      <div class="col-12 col-sm-9">
        <div class="column q-gutter-y-md ">
          <div class="col-1 row">
            <h5 class="q-ma-sm">{{ selectedProjectType?.name ?? "Все категории" }}</h5>
            <q-space/>
            <q-btn color="primary" label="Создать" class="q-ma-xs" @click="newProject = true"/>
            <q-btn color="primary" label="Скопировать" class="q-ma-xs" @click="copyProjects"
                   :disable="!user.anyAdmin && !user.admin || selectedProjects.length === 0"/>
            <q-dialog v-model="newProject" persistent>
              <new-project-form @add="addProject" @cancel="newProject = false"/>
            </q-dialog>
          </div>
          <div class="col-1">
            <q-input v-model="search" filled dense clearable/>
          </div>
          <div class="col-10">
            <projects-table v-model="selectedProjects" ref="projectTable" :admin="user.anyAdmin || user.admin" :fetch="fetchProject"
                            :search="searchTable"/>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";
import {useDebounce, useLocalStorage} from "@vueuse/core";
import {useProjectTypesStore} from "../store/projectTypes";
import {storeToRefs} from "pinia";
import ProjectsTable from "../components/ProjectsTable.vue";
import NewProjectTypeForm from "../components/NewProjectTypeForm.vue";
import {Project, ProjectType} from "../models/project";
import NewProjectForm from "../components/NewProjectForm.vue";
import {useProjects} from "../composables/project";
import {useUserStore} from "../store/user";
import {useQuasar} from "quasar";
import UpdateTasks from "../components/UpdateTasks.vue";
import UpdateProjectType from "../components/UpdateProjectType.vue";
import ProjectTypeItem from "../components/ProjectTypeItem.vue";
import CopyProjects from "../components/CopyProjects.vue";
import TransferProjectType from "../components/TransferProjectType.vue";

const $q = useQuasar()
const search = useLocalStorage("projectSearch", "")
const searchTable = useDebounce(search, 500)
const userStore = useUserStore()
const {user} = storeToRefs(userStore)
const store = useProjectTypesStore()
const projectTable = ref()
const selectedProjects = ref<Project[]>([])
store.fetch()

const {projectTypes, selectedProjectType} = storeToRefs(store)

const leftDrawerOpen = ref(false)

function select(projectType: ProjectType) {
  if (projectType.id === selectedProjectType.value?.id) {
    store.select(null)
    projectTable.value.fetch()
  } else {
    store.select(projectType)
    projectTable.value.fetch()
  }
}

const fetchProject = computed(() => useProjects(selectedProjectType?.value?.id))


const newProjectType = ref(false)
const newProject = ref(false)

function addProject() {
  projectTable.value.fetch()
  newProject.value = false
}

async function copyProjects() {
  $q.dialog({
    persistent: true,
    component: CopyProjects,
    componentProps: {
      projects: selectedProjects.value.map(p => p.id),
    },
  }).onOk(() => {
    projectTable.value.fetch()
  })
}

async function editProjectType(projectType: ProjectType) {
  $q.dialog({
    persistent: true,
    component: UpdateProjectType,
    componentProps: {
      projectType: projectType
    }
  })
}

async function transferProjectType(projectType: ProjectType) {
  $q.dialog({
    persistent: true,
    component: TransferProjectType,
    componentProps: {
      projectType: projectType
    }
  }).onOk(() => {
    projectTable.value.fetch()
    store.fetch()
  })
}

async function addProjectType(projectType?: ProjectType) {
  $q.dialog({
    persistent: true,
    component: NewProjectTypeForm,
    componentProps: {
      parentProjectType: projectType
    }
  })
}

async function deleteProjectType(projectType: ProjectType) {
  $q.dialog({
    title: 'Удаление',
    message: 'Для удаления введите имя категории',
    prompt: {
      model: '',
      isValid: val => val === projectType?.name, // << here is the magic
      type: 'text' // optional
    },
    cancel: true,
    persistent: true
  }).onOk(async data => {
    if (data === projectType?.name) {
      await store.deleteType(projectType.id)
    }

  })
}
</script>

<style scoped></style>
